// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".purchase-info .van-search__content{border-radius:50px}.purchase-info .van-tabs__content{padding:10px 20px}", ""]);
// Exports
module.exports = exports;
